import { render, staticRenderFns } from "./ProjectTicket.vue?vue&type=template&id=590bb358&scoped=true"
import script from "./ProjectTicket.vue?vue&type=script&lang=js"
export * from "./ProjectTicket.vue?vue&type=script&lang=js"
import style0 from "./ProjectTicket.vue?vue&type=style&index=0&id=590bb358&prod&scoped=true&lang=css"
import style1 from "./ProjectTicket.vue?vue&type=style&index=1&id=590bb358&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bb358",
  null
  
)

export default component.exports